module.exports = "<div class=\"row\" id=\"textEditorDirective\">\n  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" >\n    <summernote config=\"options\" class=\"summernote\" ng-model=\"text\"></summernote>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/textEditor/template.html
// module id = 1989
// module chunks = 0